export default __webpack_public_path__ + "static/media/AngsanaNew.c9629118.woff";